/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react'
import styles from './styles.module.scss'
import DUMMYPTIMAGE from '../../../../../assets/dummies/pt_image_template.jpg'
import { ReactComponent as AttachementIcon } from '../../../../../assets/icons/phone-call-svgrepo-com.svg'
import { ReactComponent as EditIcon } from '../../../../../assets/icons/edit-icon.svg'
import { ReactComponent as DeleteIco } from '../../../../../assets/icons/trash-icon.svg'
import { ReactComponent as ArrowDown } from '../../../../../assets/icons/arrow_down.svg'
import { useDispatch, useSelector } from 'react-redux'
import { uploadPatientFile } from '../../../../../Redux/patients/patientsSlice'
import { addNewAppointment, updateAppointment, deleteAppointment } from '../../../../../Redux/appointments/appointmentSlice'
import { togglePopup } from '../../../../../Redux/popups/popupSlice'
import { updatePatient } from '../../../../../Redux/patients/patientsSlice'

const PatientPage = ({
  profileId,
  fullDataPatient,
  desc,
  currentOperation,
  setCurrentOperation,
  handleEdit,
  toggleAttachmentPopup,
  printrecord,
  deletePt,
  t
}) => {
  const dispatch = useDispatch()
  
  // Get data directly from Redux store for real-time updates
  const { patients } = useSelector((state) => state.patients)
  const { appointments } = useSelector((state) => state.appointments)
  const { operations: stateOperations } = useSelector((state) => state.operations)
  
  // Get current patient data from Redux store
  const currentPatient = patients?.find((pt) => pt.id === profileId)
  
  // Create fullDataPatient from Redux store data
  const fullDataPatientFromStore = currentPatient ? {
    ...currentPatient,
    operations: currentPatient?.operations?.map((opt) => {
      const found = stateOperations.find((op) => op.id === opt.operation_id) || {}
      
      // Find the appointment for this operation instance (by init_date)
      const opAppointment = appointments.find(app =>
        app.patient_id === currentPatient?.id &&
        app.operation_id === opt.operation_id &&
        app.date === opt.init_date // match by operation_id and init_date
      );
      
      // Use the custom name only for this operation instance
      const customServiceName = opAppointment && opAppointment.name && opAppointment.name !== opAppointment.operation_name
        ? opAppointment.name
        : null;
      
      return {
        ...opt,
        ...found,
        custom_service_name: customServiceName
      }
    }),
    appointments: appointments.filter((app) => app.patient_id === currentPatient?.id)
  } : null

  // Use store data if available, otherwise fall back to props
  const effectiveFullDataPatient = fullDataPatientFromStore || fullDataPatient

  // Update currentOperation when store data changes
  useEffect(() => {
    if (currentOperation && effectiveFullDataPatient?.appointments) {
      // Find the updated appointment in the store
      const updatedAppointment = effectiveFullDataPatient.appointments.find(
        apt => apt.id === currentOperation.id
      );
      
      // If found and it's different from current, update it
      if (updatedAppointment && (
        updatedAppointment.service_cost !== currentOperation.service_cost ||
        updatedAppointment.patient_pay !== currentOperation.patient_pay ||
        updatedAppointment.difference !== currentOperation.difference
      )) {
        setCurrentOperation(updatedAppointment);
      }
    }
  }, [effectiveFullDataPatient?.appointments, currentOperation]);

  const [isOpMenuOpen, setIsOpMenuOpen] = useState(false)
  const [isUploadingPfp, setIsUploadingPfp] = useState(false)
  const [showPrintDropdown, setShowPrintDropdown] = useState(false)
  const printBtnRef = useRef(null)
  const [newAppointment, setNewAppointment] = useState({
    serviceName: '',
    date: '',
    time: ''
  })
  const [showCostEditPopup, setShowCostEditPopup] = useState(false)
  const [serviceToEdit, setServiceToEdit] = useState(null)
  const [showServicesModal, setShowServicesModal] = useState(false)
  const [selectedDateServices, setSelectedDateServices] = useState([])
  const [costEditForm, setCostEditForm] = useState({
    service_cost: 0,
    patient_pay: 0,
    difference: 0,
    new_payment: 0,
    selected_date: new Date().toISOString().split('T')[0], // Shto datën e zgjedhur
    payments_array: [], // Array i pagesave me datat e tyre
    showInstallments: false
  })

  const { category, color, op_name } = currentOperation || {
    category: t('unassigned'),
    color: '#000'
  }

  const { full_name, email, dob, phone, location, operations, attachements } = effectiveFullDataPatient || {}

  const pfp = attachements?.find((el) => el.type === 'pfp')

  const getServiceColor = (serviceName) => {
    const operation = stateOperations?.find(op => op.op_name === serviceName)
    return operation?.color || '#0288d1'
  }

  // Function to group appointments by date
  const groupAppointmentsByDate = (appointments) => {
    if (!appointments || !Array.isArray(appointments)) return {}
    
    return appointments.reduce((grouped, appointment) => {
      const date = appointment.date
      if (!grouped[date]) {
        grouped[date] = []
      }
      grouped[date].push(appointment)
      return grouped
    }, {})
  }

  // Function to handle clicking on a grouped service card
  const handleGroupedServiceClick = (date, services) => {
    // If there's only one service, select it directly without opening modal
    if (services.length === 1) {
      setCurrentOperation(services[0])
    } else {
      // If there are multiple services, open the modal for selection
      setSelectedDateServices(services)
      setShowServicesModal(true)
    }
  }

  // Function to handle clicking on individual service in modal
  const handleServiceSelect = (service) => {
    setCurrentOperation(service)
    setShowServicesModal(false)
  }

  const onPfpUploadProgress = (value) => {
    setIsUploadingPfp(value)
    if (value >= 100) {
      setTimeout(() => {
        setIsUploadingPfp(false)
      }, 500)
    }
  }

  const fileUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return
    dispatch(uploadPatientFile({ file, type: 'pfp', profileId, onProgress: onPfpUploadProgress }))
  }

  const handleAppointmentSubmit = (e) => {
    e.preventDefault()
    
    // Convert time to from/to format
    const [hours, minutes] = newAppointment.time.split(':')
    const from = parseFloat(hours) + parseFloat(minutes) / 60
    const to = from + 0.5 // 30 minutes duration

    const appointment = {
      date: newAppointment.date,
      from,
      to,
      fromStr: newAppointment.time,
      toStr: `${hours}:${parseInt(minutes) + 30}`,
      name: newAppointment.serviceName,
      services: [newAppointment.serviceName],
      operation_id: Date.now().toString(),
      operation_name: newAppointment.serviceName,
      patient_id: profileId,
      patient_name: full_name,
      doctor_id: '',
      doctor_name: '',
      category: t('general'),
      color: '#0288d1',
      service_cost: 0,
      patient_pay: 0,
      difference: 0,
      is_ongoing: true,
      unit_multiplier: 1,
      array_of_payments: [],
      price: 0,
      is_paid: false,
      teeth_list: [],
      room: '',
      feedback: '',
      examination: '',
      therapy: '',
      description: ''
    }
    
    // Dispatch the action to save the appointment
    dispatch(addNewAppointment({
      ...appointment,
      close: () => {
        // Reset the form after successful save
        setNewAppointment({
          serviceName: '',
          date: '',
          time: ''
        })
      }
    }))
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewAppointment(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const selectService = (operation) => {
    setCurrentOperation(operation);
    setIsOpMenuOpen(false);
  }

  const openFastServicesPopup = () => {
    dispatch(togglePopup({
      pointer: 10,
      data: {
        patient_id: profileId,
        patient_name: full_name
      }
    }))
  }

  const openCostEditPopup = (e, service) => {
    e.stopPropagation();
    setServiceToEdit(service);
    
    if (service.isGrouped) {
      // Handle grouped services - treat as one unit
      const totalCost = service.services.reduce((sum, s) => sum + (s.service_cost !== undefined ? s.service_cost : (s.price !== undefined ? s.price : 0)), 0);
      const totalPaid = service.services.reduce((sum, s) => sum + (s.patient_pay !== undefined ? s.patient_pay : (s.paid_amount !== undefined ? s.paid_amount : 0)), 0);
      
      // Collect all payments from grouped services
      const allPayments = [];
      service.services.forEach((s, serviceIndex) => {
        if (Array.isArray(s.array_of_payments)) {
          s.array_of_payments.forEach((payment, paymentIndex) => {
            allPayments.push({
              id: `grouped_${serviceIndex}_${paymentIndex}_${Date.now()}`,
              amount: Number(payment.amount) || Number(payment.value) || 0,
              date: payment.date || new Date().toISOString().split('T')[0],
              isExisting: true,
              appointmentId: s.id,
              serviceName: s.name || s.operation_name
            });
          });
        }
      });
      
      setCostEditForm({
        service_cost: totalCost,
        patient_pay: totalPaid,
        difference: totalCost - totalPaid,
        new_payment: 0,
        selected_date: new Date().toISOString().split('T')[0],
        payments_array: allPayments,
        showInstallments: false
      });
    } else if (service.id === 'total') {
      // Calculate total costs properly handling zero values
      const totalCost = effectiveFullDataPatient?.appointments?.reduce((sum, apt) => 
        sum + (apt.service_cost !== undefined ? apt.service_cost : (apt.price !== undefined ? apt.price : 0)), 0) || 0;
      
      const totalPaid = effectiveFullDataPatient?.appointments?.reduce((sum, apt) => {
        const serviceCost = apt.service_cost !== undefined ? apt.service_cost : (apt.price !== undefined ? apt.price : 0);
        const patientPay = apt.patient_pay !== undefined ? apt.patient_pay : (apt.paid_amount !== undefined ? apt.paid_amount : 0);
        return sum + Math.min(patientPay, serviceCost);
      }, 0) || 0;
      
      // Collect all payments from all appointments for total cost view
      const allPayments = [];
      effectiveFullDataPatient?.appointments?.forEach((apt, aptIndex) => {
        if (Array.isArray(apt.array_of_payments)) {
          apt.array_of_payments.forEach((payment, paymentIndex) => {
            allPayments.push({
              id: `total_${aptIndex}_${paymentIndex}_${Date.now()}`,
              amount: Number(payment.amount) || Number(payment.value) || 0,
              date: payment.date || new Date().toISOString().split('T')[0],
              isExisting: true,
              appointmentId: apt.id,
              serviceName: apt.name || apt.operation_name
            });
          });
        }
      });
      
      setCostEditForm({
        service_cost: totalCost,
        patient_pay: totalPaid,
        difference: totalCost - totalPaid,
        new_payment: 0,
        selected_date: new Date().toISOString().split('T')[0],
        payments_array: allPayments, // Include all payments from all appointments
        showInstallments: false
      });
    } else {
      // Get service cost from either service_cost or price (legacy)
      const serviceCost = service.service_cost !== undefined ? service.service_cost : (service.price !== undefined ? service.price : 0);
      
      // Get patient payment from either patient_pay or paid_amount (legacy) 
      const patientPay = service.patient_pay !== undefined ? service.patient_pay : (service.paid_amount !== undefined ? service.paid_amount : 0);
      
      // Calculate difference
      const difference = serviceCost - patientPay;
      
      // Populoj payments_array me pagesat ekzistuese
      const existingPayments = Array.isArray(service.array_of_payments) 
        ? service.array_of_payments.map((payment, index) => ({
            id: `existing_${index}_${Date.now()}`, // Unique ID për pagesat ekzistuese
            amount: Number(payment.amount) || Number(payment.value) || 0,
            date: payment.date || new Date().toISOString().split('T')[0],
            isExisting: true // Markojmë si ekzistuese
          }))
        : [];
      
      setCostEditForm({
        service_cost: serviceCost,
        patient_pay: patientPay,
        difference: difference,
        new_payment: 0,
        selected_date: new Date().toISOString().split('T')[0],
        payments_array: existingPayments,
        showInstallments: false
      });
    }
    
    setShowCostEditPopup(true);
  }

  const handleCostEditChange = (e) => {
    const { name, value } = e.target;
    
    // Handle date field differently - keep as string
    let processedValue;
    if (name === 'selected_date') {
      processedValue = value; // Keep date as string
    } else {
      processedValue = parseFloat(value) || 0; // Parse numbers
    }
    
    const updatedForm = { ...costEditForm, [name]: processedValue };
    
    if (name === 'service_cost' || name === 'patient_pay') {
      updatedForm.difference = updatedForm.service_cost - updatedForm.patient_pay;
    }
    
    // Nëse ndryshohet patient_pay
    if (name === 'patient_pay') {
      if (processedValue > 0) {
        // Nëse pagesa është më e madhe se 0, ruaje automatikisht si pagese me keste
        const currentTotalFromPayments = costEditForm.payments_array.reduce((sum, payment) => sum + payment.amount, 0);
        const difference = processedValue - currentTotalFromPayments;
        
        if (difference !== 0) {
          // Nëse ka ndryshim, shto një pagesë të re ose përditëso pagesën ekzistuese
          const today = new Date().toISOString().split('T')[0];
          const existingPaymentIndex = costEditForm.payments_array.findIndex(
            payment => payment.date === today
          );
          
          let updatedPayments = [...costEditForm.payments_array];
          
          if (existingPaymentIndex !== -1) {
            // Përditëso pagesën ekzistuese për sot
            updatedPayments[existingPaymentIndex] = {
              ...updatedPayments[existingPaymentIndex],
              amount: updatedPayments[existingPaymentIndex].amount + difference
            };
          } else {
            // Shto një pagesë të re për sot
            const newPayment = {
              id: `auto_${Date.now()}_${Math.random()}`,
              amount: difference,
              date: today,
              isExisting: false
            };
            updatedPayments.push(newPayment);
          }
          
          updatedForm.payments_array = updatedPayments;
        }
      } else if (processedValue === 0) {
        // Nëse pagesa bëhet 0, hiq të gjitha pagesat me keste
        updatedForm.payments_array = [];
      }
    }
    
    setCostEditForm(updatedForm);
  }

  // Funksion për të menaxhuar ndryshimet në pagesat individuale
  const handlePaymentChange = (paymentId, field, value) => {
    const updatedPayments = costEditForm.payments_array.map(payment => 
      payment.id === paymentId 
        ? { ...payment, [field]: field === 'amount' ? (parseFloat(value) || 0) : value }
        : payment
    );
    
    // Llogarit totalin e ri të pagesave
    const newTotalPay = updatedPayments.reduce((sum, payment) => sum + payment.amount, 0);
    
    setCostEditForm({
      ...costEditForm,
      payments_array: updatedPayments,
      patient_pay: newTotalPay,
      difference: costEditForm.service_cost - newTotalPay
    });
  }

  // Funksion për të shtuar një pagesë të re
  const addNewPayment = () => {
    if (costEditForm.new_payment > 0) {
      // Kontrolloj nëse ka një pagesë ekzistuese për këtë datë
      const existingPaymentIndex = costEditForm.payments_array.findIndex(
        payment => payment.date === costEditForm.selected_date
      );
      
      let updatedPayments;
      
      if (existingPaymentIndex !== -1) {
        // Nëse ka pagesë ekzistuese për këtë datë, përditësoj shuma
        updatedPayments = costEditForm.payments_array.map((payment, index) => 
          index === existingPaymentIndex 
            ? { ...payment, amount: payment.amount + costEditForm.new_payment }
            : payment
        );
      } else {
        // Nëse nuk ka pagesë për këtë datë, shto pagesë të re
        const newPayment = {
          id: `new_${Date.now()}_${Math.random()}`, // ID unik për pagesat e reja
          amount: costEditForm.new_payment,
          date: costEditForm.selected_date,
          isExisting: false, // Markojmë si të re
          // For total cost popup, assign to first appointment with balance
          appointmentId: serviceToEdit?.id === 'total' ? 
            (effectiveFullDataPatient?.appointments?.find(apt => {
              const serviceCost = apt.service_cost || apt.price || 0;
              const currentPay = apt.patient_pay || apt.paid_amount || 0;
              return serviceCost > currentPay;
            })?.id || effectiveFullDataPatient?.appointments?.[0]?.id) : null
        };
        updatedPayments = [...costEditForm.payments_array, newPayment];
      }
      
      const newTotalPay = updatedPayments.reduce((sum, payment) => sum + payment.amount, 0);
      
      setCostEditForm({
        ...costEditForm,
        payments_array: updatedPayments,
        patient_pay: newTotalPay,
        difference: costEditForm.service_cost - newTotalPay,
        new_payment: 0
      });
    }
  }

  // Funksion për të fshirë një pagesë
  const removePayment = (paymentId) => {
    // Find the payment to be removed
    const paymentToRemove = costEditForm.payments_array.find(payment => payment.id === paymentId);
    
    if (!paymentToRemove) return;
    
    const updatedPayments = costEditForm.payments_array.filter(payment => payment.id !== paymentId);
    const newTotalPay = updatedPayments.reduce((sum, payment) => sum + payment.amount, 0);
    
    // If this is a total cost edit and we're removing an existing payment
    if (serviceToEdit?.id === 'total' && paymentToRemove.isExisting && paymentToRemove.appointmentId) {
      // Find the appointment and remove the payment from it
      const appointments = effectiveFullDataPatient?.appointments || [];
      const targetAppointment = appointments.find(apt => apt.id === paymentToRemove.appointmentId);
      
      if (targetAppointment && Array.isArray(targetAppointment.array_of_payments)) {
        // Remove the payment from the appointment's array_of_payments
        const updatedAppointmentPayments = targetAppointment.array_of_payments.filter(payment => {
          // Match by amount, date, and other properties to identify the specific payment
          return !(
            (payment.amount === paymentToRemove.amount || payment.value === paymentToRemove.amount) &&
            payment.date === paymentToRemove.date
          );
        });
        
        // Update the appointment with the removed payment
        const totalPaymentsAmount = updatedAppointmentPayments.reduce((sum, p) => sum + (p.amount || p.value || 0), 0);
        const updatedApt = {
          ...targetAppointment,
          array_of_payments: updatedAppointmentPayments,
          patient_pay: Math.min(totalPaymentsAmount, targetAppointment.service_cost || targetAppointment.price || 0),
          difference: (targetAppointment.service_cost || targetAppointment.price || 0) - Math.min(totalPaymentsAmount, targetAppointment.service_cost || targetAppointment.price || 0)
        };
        
        // Update the appointment immediately
        dispatch(updateAppointment(updatedApt));
      }
    }
    
    setCostEditForm({
      ...costEditForm,
      payments_array: updatedPayments,
      patient_pay: newTotalPay,
      difference: costEditForm.service_cost - newTotalPay
    });
  }

  const saveCostChanges = () => {
    if (!serviceToEdit) return;
    
    if (costEditForm.patient_pay > costEditForm.service_cost) {
      alert(t('patient_pay_cannot_exceed_service_cost') || 'Pagesa e pacientit nuk mund të jetë më e madhe se kostoja e shërbimit');
      return;
    }
    
    if (serviceToEdit.isGrouped) {
      // Handle grouped services update - distribute costs proportionally
      const appointments = serviceToEdit.services;
      if (appointments.length === 0) {
        alert(t('no_appointments_to_update_costs') || 'Nuk ka takime për të përditësuar kostot');
        setShowCostEditPopup(false);
        return;
      }
      
      // Calculate proportional distribution of costs based on original service costs
      const originalTotalCost = appointments.reduce((sum, apt) => sum + (apt.service_cost !== undefined ? apt.service_cost : (apt.price !== undefined ? apt.price : 0)), 0);
      const newTotalCost = costEditForm.service_cost;
      const newTotalPaid = costEditForm.patient_pay;
      
      // Prepare payments array
      let paymentsArrayToUse = [...costEditForm.payments_array];
      if (paymentsArrayToUse.length === 0 && newTotalPaid > 0) {
        const firstAptId = appointments[0]?.id;
        paymentsArrayToUse = [{
          id: `auto_${Date.now()}_${Math.random()}`,
          amount: newTotalPaid,
          value: newTotalPaid,
          date: new Date().toISOString().split('T')[0],
          isExisting: false,
          appointmentId: firstAptId
        }];
      }
      
      // Waterfall distribution: fill appointments with payments until their cost is covered or payments run out
      let remainingPayments = paymentsArrayToUse.map(p => ({ ...p }));
      let updatedAppointments = appointments.map(apt => {
        const originalServiceCost = apt.service_cost || apt.price || 0;
        // Keep original service cost proportions or distribute evenly if original total is 0
        let serviceCost = originalTotalCost > 0 
          ? (originalServiceCost / originalTotalCost) * newTotalCost
          : newTotalCost / appointments.length;
        
        let paymentsForThisApt = [];
        let totalPaidForThisApt = 0;
        
        // Fill this appointment with payments until its cost is covered or payments run out
        while (remainingPayments.length > 0 && totalPaidForThisApt < serviceCost) {
          let payment = remainingPayments[0];
          let amountToApply = Math.min(payment.amount, serviceCost - totalPaidForThisApt);
          
          if (amountToApply > 0) {
            paymentsForThisApt.push({
              amount: amountToApply,
              value: amountToApply,
              date: payment.date
            });
            totalPaidForThisApt += amountToApply;
            payment.amount -= amountToApply;
          }
          
          if (payment.amount <= 0) {
            remainingPayments.shift(); // Remove fully used payment
          }
        }
        
        return {
          ...apt,
          service_cost: Math.round(serviceCost),
          array_of_payments: paymentsForThisApt,
          patient_pay: Math.round(totalPaidForThisApt),
          difference: Math.round(serviceCost - totalPaidForThisApt),
          payment_date: paymentsForThisApt.length > 0 ? paymentsForThisApt[paymentsForThisApt.length - 1].date : apt.payment_date
        };
      });
      
      // Dispatch updates for each appointment
      updatedAppointments.forEach(updatedApt => {
        dispatch(updateAppointment(updatedApt));
      });
      
      // Update currentOperation if it's one of the services being edited
      if (currentOperation) {
        const updatedCurrentOperation = updatedAppointments.find(apt => apt.id === currentOperation.id);
        if (updatedCurrentOperation) {
          setCurrentOperation(updatedCurrentOperation);
        }
      }
      
      setShowCostEditPopup(false);
      return;
    } else if (serviceToEdit.id === 'total') {
      // Get all appointments
      const appointments = effectiveFullDataPatient?.appointments || [];
      if (appointments.length === 0) {
        alert(t('no_appointments_to_update_costs') || 'Nuk ka takime për të përditësuar kostot');
        setShowCostEditPopup(false);
        return;
      }
      let paymentsArrayToUse = [...costEditForm.payments_array];
      if (paymentsArrayToUse.length === 0 && costEditForm.patient_pay > 0) {
        const firstAptId = appointments.find(apt => (apt.service_cost || apt.price || 0) > (apt.patient_pay || apt.paid_amount || 0))?.id || appointments[0]?.id;
        paymentsArrayToUse = [{
          id: `auto_${Date.now()}_${Math.random()}`,
          amount: costEditForm.patient_pay,
          value: costEditForm.patient_pay,
          date: new Date().toISOString().split('T')[0],
          isExisting: false,
          appointmentId: firstAptId
        }];
      }
      // Calculate total cost for proportional distribution
      const totalServiceCost = appointments.reduce((sum, apt) => sum + (apt.service_cost !== undefined ? apt.service_cost : (apt.price !== undefined ? apt.price : 0)), 0) || 0;
      // Prepare a copy of appointments to update
      let remainingPayments = paymentsArrayToUse.map(p => ({ ...p }));
      let updatedAppointments = appointments.map(apt => {
        const oldServiceCost = apt.service_cost || apt.price || 0;
        let serviceCost = oldServiceCost;
        let paymentsForThisApt = [];
        let totalPaidForThisApt = 0;
        // Waterfall: fill this appointment with payments until its cost is covered or payments run out
        while (remainingPayments.length > 0 && totalPaidForThisApt < serviceCost) {
          let payment = remainingPayments[0];
          let amountToApply = Math.min(payment.amount, serviceCost - totalPaidForThisApt);
          if (amountToApply > 0) {
            paymentsForThisApt.push({
              amount: amountToApply,
              value: amountToApply,
              date: payment.date
            });
            totalPaidForThisApt += amountToApply;
            payment.amount -= amountToApply;
          }
          if (payment.amount <= 0) {
            remainingPayments.shift(); // Remove fully used payment
          }
        }
        return {
          ...apt,
          array_of_payments: paymentsForThisApt,
          patient_pay: totalPaidForThisApt,
          difference: serviceCost - totalPaidForThisApt,
          payment_date: paymentsForThisApt.length > 0 ? paymentsForThisApt[paymentsForThisApt.length - 1].date : apt.payment_date
        };
      });
      // Dispatch updates for each appointment
      updatedAppointments.forEach(updatedApt => {
        dispatch(updateAppointment(updatedApt));
      });
      setCurrentOperation(null);
    } else {
      // Handle single service update
      const updatedService = {
        ...serviceToEdit,
        service_cost: Math.round(costEditForm.service_cost),
        patient_pay: Math.round(costEditForm.patient_pay),
        difference: Math.round(costEditForm.difference)
      };
      
      // Përditëso array_of_payments me pagesat e reja nga forma
      let paymentsArrayToSave = [...costEditForm.payments_array];
      if (paymentsArrayToSave.length === 0 && costEditForm.patient_pay > 0) {
        // Nëse nuk ka pagesa të regjistruara, krijo një pagesë me shumën totale dhe datën e sotme
        paymentsArrayToSave = [{
          id: `auto_${Date.now()}_${Math.random()}`,
          amount: costEditForm.patient_pay,
          value: costEditForm.patient_pay,
          date: new Date().toISOString().split('T')[0],
          isExisting: false
        }];
      }
      if (paymentsArrayToSave.length > 0) {
        // Llogarit totalin e vërtetë nga pagesat aktuale
        const actualTotalPaid = paymentsArrayToSave.reduce((sum, payment) => sum + payment.amount, 0);
        
        updatedService.array_of_payments = paymentsArrayToSave.map(payment => ({
          amount: payment.amount,
          value: payment.amount, // për kompatibilitet me prapa
          date: payment.date
        }));
        
        // Sigurohu që patient_pay përputhet me totalin e vërtetë nga pagesat
        updatedService.patient_pay = Math.round(actualTotalPaid);
        updatedService.difference = Math.round(costEditForm.service_cost - actualTotalPaid);
        
        // Vendos payment_date nga pagesa e fundit
        const sortedPayments = [...paymentsArrayToSave].sort((a, b) => new Date(a.date) - new Date(b.date));
        if (sortedPayments.length > 0) {
          updatedService.payment_date = sortedPayments[sortedPayments.length - 1].date;
        }
      } else {
        // Nëse nuk ka pagesa, pastro array_of_payments
        updatedService.array_of_payments = [];
        updatedService.patient_pay = 0;
        updatedService.difference = Math.round(costEditForm.service_cost);
        if (costEditForm.patient_pay > 0) {
          updatedService.payment_date = costEditForm.selected_date || new Date().toISOString().split('T')[0];
        }
      }
      
      dispatch(updateAppointment(updatedService));
      
      // Update currentOperation if it's the service being edited
      if (currentOperation && currentOperation.id === serviceToEdit.id) {
        setCurrentOperation(updatedService);
      }
    }
    
    setShowCostEditPopup(false);
  }

  const handleDeleteService = (e, service) => {
    e.stopPropagation();
    dispatch(togglePopup({
      pointer: 11, // Using a new popup type for delete confirmation
      data: {
        service,
        onConfirm: () => {
          dispatch(deleteAppointment({ 
            id: service.id, 
            keepInPatientRecord: false,
            close: () => {
              // Përditëso state-in lokal të pacientit pa rifreskuar faqen
              if (effectiveFullDataPatient && effectiveFullDataPatient.appointments) {
                const updatedAppointments = effectiveFullDataPatient.appointments.filter(apt => apt.id !== service.id);
                effectiveFullDataPatient.appointments = updatedAppointments;
              }
              if (currentOperation?.id === service.id) {
                setCurrentOperation(null);
              }
            }
          }));
        }
      }
    }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.communicative_profile}>
        <div className={styles.img_container}>
          <input className={styles.input_file_upload} onChange={fileUpload} type='file' id='file' style={{ display: 'none' }} />
          <label className={styles.label_file_upload} htmlFor='file'></label>
          <img className={styles.profile_image} src={pfp?.url || DUMMYPTIMAGE} alt={t('patient')} />
          {isUploadingPfp && (
            <div className={styles.pfp_loading_container}>
              <div
                className={styles.pfp_loading}
                style={{
                  left: isUploadingPfp + '%'
                }}
              ></div>
            </div>
          )}
        </div>
        <div className={styles.profile_header}>
          <div className={styles.profile_name}>{full_name || t('anonymous')}</div>
          <div className={styles.profile_email}>
            {t('email')}: {email || 'N/A'}
          </div>
          <div className={styles.profile_email}>
            {t('phone')}: {phone || 'N/A'}
          </div>
          <div className={styles.profile_email}>
            {t('location')}: {location || 'N/A'}
          </div>
        </div>
        <div className={styles.profile_scoial_control}>
          <button className={styles.profile_social_button} onClick={deletePt && deletePt} title={t('delete_patient')}>
            <DeleteIco className={styles.profile_social_logo} />
          </button>
          <button className={styles.profile_social_button} onClick={handleEdit && handleEdit} title={t('edit_patient')}>
            <EditIcon className={styles.profile_social_logo} />
          </button>
          <button className={styles.profile_social_button} onClick={toggleAttachmentPopup} title={t('attachments')}>
            <AttachementIcon className={styles.profile_social_logo} />
          </button>
          <button
            ref={printBtnRef}
            onClick={() => {
              // If no service is selected, use the last service from appointments
              const serviceToPrint = currentOperation || (effectiveFullDataPatient?.appointments?.length > 0 ? effectiveFullDataPatient.appointments[effectiveFullDataPatient.appointments.length - 1] : {});
              printrecord({
                ...serviceToPrint,
                main_issue: serviceToPrint?.main_issue || serviceToPrint?.description,
                custom_service_name: serviceToPrint?.custom_service_name || serviceToPrint?.name,
                op_name: serviceToPrint?.op_name || serviceToPrint?.operation_name,
                init_date: serviceToPrint?.init_date || serviceToPrint?.date,
                feedback: serviceToPrint?.feedback,
                examination: serviceToPrint?.examination,
                therapy: serviceToPrint?.therapy
              });
            }}
            className={`${styles.profile_social_button} ${styles.dl_records}`}
          >
            {t('print_record')}
          </button>
        </div>
      </div>
      <div className={styles.info_profile}>
        <h3 className={styles.info_profile_header}>{t('general_information')}</h3>
        <div className={styles.info_profile_case_container}>
          <div className={styles.info_profile_case}>
            <span className={styles.info_profile_label}>{t('date_of_birth')}:</span>
            <span className={styles.info_profile_data}>{dob ? new Date(dob).getFullYear() : 'N/A'}</span>
          </div>
        </div>
      </div>

      {/* Cost information section */}
      <div className={styles.cost_information_section}>
        <h3 className={styles.info_profile_header}>
          {t('cost_information')}
          <div className={styles.cost_header_actions}>
            {currentOperation && (
              <button 
                className={styles.show_all_costs_btn}
                onClick={() => setCurrentOperation(null)}
              >
                {t('show_all_costs')}
              </button>
            )}
            <button 
              className={styles.edit_total_cost_btn}
              onClick={(e) => {
                const totalCost = effectiveFullDataPatient?.appointments?.reduce((sum, apt) => 
                  sum + (apt.service_cost || apt.price || 0), 0);
                const totalPaid = effectiveFullDataPatient?.appointments?.reduce((sum, apt) => {
                  const serviceCost = apt.service_cost || apt.price || 0;
                  const patientPay = apt.patient_pay || apt.paid_amount || 0;
                  return sum + Math.min(patientPay, serviceCost);
                }, 0);
                openCostEditPopup(e, {
                  id: 'total',
                  service_cost: totalCost,
                  patient_pay: totalPaid,
                  difference: totalCost - totalPaid
                });
              }}
              title={t('edit_total_costs')}
            >
              <EditIcon className={styles.edit_icon} />
            </button>
          </div>
        </h3>
        
        {/* Vetëm pjesa e sipërme fillimisht */}
        <div className={styles.cost_section_label}>
          {currentOperation 
            ? (currentOperation.name || currentOperation.operation_name) 
            : t('all_services')}
        </div>
        <div className={`${styles.cost_info_row} ${styles.total_row}`}>
          <div className={styles.cost_info_item}>
            <div className={styles.cost_info_label}>
              {currentOperation 
                ? t('service_cost')
                : t('total_service_cost')}
            </div>
            <div className={styles.cost_info_value}>
              {currentOperation 
                ? (currentOperation.service_cost !== undefined ? currentOperation.service_cost : (currentOperation.price !== undefined ? currentOperation.price : 0))
                : effectiveFullDataPatient?.appointments?.reduce((sum, apt) => 
                    sum + (apt.service_cost !== undefined ? apt.service_cost : (apt.price !== undefined ? apt.price : 0)), 0).toFixed(2)} €
            </div>
          </div>
          <div className={styles.cost_info_divider}></div>
          <div className={styles.cost_info_item}>
            <div className={styles.cost_info_label}>
              {currentOperation 
                ? t('patient_payment')
                : t('total_patient_pay')}
            </div>
            <div className={styles.cost_info_value}>
              {currentOperation 
                ? (currentOperation.patient_pay !== undefined ? currentOperation.patient_pay : (currentOperation.paid_amount !== undefined ? currentOperation.paid_amount : 0))
                : effectiveFullDataPatient?.appointments?.reduce((sum, apt) => {
                    const patientPay = apt.patient_pay !== undefined ? apt.patient_pay : (apt.paid_amount !== undefined ? apt.paid_amount : 0);
                    return sum + patientPay;
                  }, 0).toFixed(2)} €
            </div>
          </div>
          <div className={styles.cost_info_divider}></div>
          <div className={styles.cost_info_item}>
            <div className={styles.cost_info_label}>{t('difference')}</div>
            <div className={styles.cost_info_value}>
              {currentOperation 
                ? (currentOperation.difference !== undefined ? currentOperation.difference : 0)
                : (effectiveFullDataPatient?.appointments?.reduce((sum, apt) => {
                    const serviceCost = apt.service_cost !== undefined ? apt.service_cost : (apt.price !== undefined ? apt.price : 0);
                    const patientPay = apt.patient_pay !== undefined ? apt.patient_pay : (apt.paid_amount !== undefined ? apt.paid_amount : 0);
                    return sum + (serviceCost - patientPay);
                  }, 0) || 0).toFixed(2)} €
            </div>
          </div>
        </div>
      </div>

      <div className={styles.description_profile_case}>
        <div className={styles.section_header}>
          <h3 className={styles.info_profile_header}>{t('operation')}</h3>
          <button onClick={openFastServicesPopup} className={styles.add_fast_service_btn}>
            {t('add_fast_service')}
          </button>
        </div>
        
        <div className={styles.services_cards_container}>
          {effectiveFullDataPatient?.appointments?.length ? (
            Object.entries(groupAppointmentsByDate(effectiveFullDataPatient.appointments))
              .sort((a, b) => new Date(a[0]) - new Date(b[0]))
              .map(([date, services]) => {
                const totalCost = services.reduce((sum, service) => 
                  sum + (service.service_cost !== undefined ? service.service_cost : (service.price !== undefined ? service.price : 0)), 0)
                const hasActiveService = services.some(service => service.id === currentOperation?.id)
                
                return (
                  <div
                    key={date}
                    className={
                      `${styles.service_card} ${styles.grouped_service_card} ` +
                      (hasActiveService ? styles.active_card : '')
                    }
                    style={{ 
                      borderLeft: `3px solid ${services.length > 1 ? '#4caf50' : getServiceColor(services[0].name || services[0].operation_name)}`,
                      cursor: 'pointer' 
                    }}
                    onClick={() => handleGroupedServiceClick(date, services)}
                  >
                    <div className={styles.service_card_header}>
                      <span className={styles.service_name}>
                        {services.length === 1 
                          ? services[0].name || services[0].operation_name
                          : `${services.length} ${t('services')}`
                        }
                      </span>
                      <div className={styles.service_card_actions}>
                        {services.length === 1 && (
                          <>
                            <button 
                              className={styles.cost_edit_btn}
                              onClick={(e) => {
                                e.stopPropagation()
                                openCostEditPopup(e, services[0])
                              }}
                              title={t('edit_cost')}
                            >
                              <span role="img" aria-label="edit cost">💶</span>
                            </button>
                            <button 
                              className={styles.delete_service_btn}
                              onClick={(e) => {
                                e.stopPropagation()
                                handleDeleteService(e, services[0])
                              }}
                              title={t('delete_service')}
                            >
                              <DeleteIco className={styles.delete_icon} />
                            </button>
                          </>
                        )}
                        {services.length > 1 && (
                          <>
                            <button 
                              className={styles.cost_edit_btn}
                              onClick={(e) => {
                                e.stopPropagation()
                                openCostEditPopup(e, {
                                  id: `grouped_${date}`,
                                  isGrouped: true,
                                  date: date,
                                  services: services,
                                  service_cost: services.reduce((sum, s) => sum + (s.service_cost || s.price || 0), 0),
                                  patient_pay: services.reduce((sum, s) => sum + (s.patient_pay || s.paid_amount || 0), 0)
                                })
                              }}
                              title={t('edit_costs')}
                            >
                              <span role="img" aria-label="edit costs">💶</span>
                            </button>
                            <span className={styles.services_count_badge}>
                              {services.length}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className={styles.service_card_body}>
                      <span className={styles.service_date}>
                        {date ? new Date(date).toLocaleDateString('en-GB') : ''}
                      </span>
                      {totalCost > 0 && (
                        <div className={styles.card_cost_info}>
                          <span className={styles.cost_label}>{t('total_cost')}:</span>
                          <span className={styles.cost_value}>{totalCost.toFixed(2)} €</span>
                        </div>
                      )}
                      {services.length > 1 && (
                        <div className={styles.services_preview}>
                          {services.slice(0, 2).map((service, index) => (
                            <span key={service.id} className={styles.service_preview_item}>
                              {service.name || service.operation_name}
                              {index < 1 && services.length > 2 ? ', ' : ''}
                            </span>
                          ))}
                          {services.length > 2 && (
                            <span className={styles.more_services}>
                              +{services.length - 2} {t('more')}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )
              })
          ) : null}
        </div>
      </div>

      {showCostEditPopup && serviceToEdit && (
        <div className={styles.cost_edit_popup_overlay}>
          <div className={styles.cost_edit_popup}>
            <div className={styles.popup_header}>
              <h3>
                {serviceToEdit.id === 'total' 
                  ? t('edit_total_costs')
                  : serviceToEdit.isGrouped
                    ? `${t('edit_costs')} - ${new Date(serviceToEdit.date).toLocaleDateString('en-GB')}`
                    : t('edit_service_cost')}
              </h3>
              <button 
                className={styles.close_popup_btn}
                onClick={() => setShowCostEditPopup(false)}
              >
                ✖
              </button>
            </div>
            <div className={styles.popup_content}>
              <div className={styles.edit_form_container}>
                {/* Main cost inputs in a compact layout */}
                <div className={styles.cost_inputs_grid}>
                  <div className={styles.form_group}>
                    <label htmlFor="service_cost">{t('service_cost')}</label>
                    <div className={styles.input_with_currency}>
                      <input
                        type="number"
                        id="service_cost" 
                        name="service_cost"
                        value={costEditForm.service_cost}
                        onChange={handleCostEditChange}
                        className={styles.form_input}
                        min="0"
                        step="0.01"
                        placeholder="0.00"
                      />
                      <span className={styles.currency_symbol}>€</span>
                    </div>
                  </div>
                  <div className={styles.form_group}>
                    <label htmlFor="patient_pay">{t('patient_pay')}</label>
                    <div className={styles.input_with_currency}>
                      <input
                        type="number"
                        id="patient_pay" 
                        name="patient_pay"
                        value={costEditForm.patient_pay}
                        onChange={handleCostEditChange}
                        className={styles.form_input}
                        min="0"
                        max={costEditForm.service_cost}
                        step="0.01"
                        placeholder="0.00"
                      />
                      <span className={styles.currency_symbol}>€</span>
                    </div>
                  </div>
                  <div className={styles.form_group}>
                    <label htmlFor="difference">{t('difference')}</label>
                    <div className={styles.input_with_currency}>
                      <input
                        type="number"
                        id="difference" 
                        name="difference"
                        value={costEditForm.difference}
                        className={`${styles.form_input} ${styles.difference_input}`}
                        readOnly
                      />
                      <span className={styles.currency_symbol}>€</span>
                    </div>
                  </div>
                </div>
                
                {costEditForm.patient_pay > costEditForm.service_cost && (
                  <div className={styles.error_message}>
                    {t('patient_pay_cannot_exceed_service_cost')}
                  </div>
                )}
                {/* Butoni për pagesa me këste */}
                {!costEditForm.showInstallments && (
                  <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                    <button type="button" className={styles.installments_btn} onClick={() => setCostEditForm({ ...costEditForm, showInstallments: true })}>
                      Pagesa me këste
                    </button>
                  </div>
                )}
                {/* Seksioni i pagesave me këste - dizajn i thjeshtuar */}
                {costEditForm.showInstallments && (
                  <div className={styles.payments_section}>
                    <div className={styles.payments_header}>
                      <h4>Pagesat e Bëra ({costEditForm.payments_array.length})</h4>
                      <span className={styles.total_paid}>
                        Total: {costEditForm.payments_array.reduce((sum, payment) => sum + payment.amount, 0).toFixed(2)} €
                      </span>
                    </div>
                    
                    {/* Tabelë kompakte për pagesat */}
                    {costEditForm.payments_array.length > 0 && (
                      <div className={styles.payments_table_container}>
                        <table className={styles.payments_table}>
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Shuma</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {costEditForm.payments_array
                              .sort((a, b) => new Date(a.date) - new Date(b.date))
                              .map((payment) => (
                              <tr key={payment.id}>
                                <td>{new Date(payment.date).toLocaleDateString('en-GB')}</td>
                                <td>{payment.amount.toFixed(2)} €</td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => removePayment(payment.id)}
                                    className={styles.remove_btn_small}
                                    title="Fshi"
                                  >
                                    ×
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    
                    {/* Forma kompakte për shtim pagese */}
                    <div className={styles.add_payment_compact}>
                      <div className={styles.add_payment_inputs}>
                        <input
                          type="number"
                          value={costEditForm.new_payment}
                          onChange={(e) => setCostEditForm({
                            ...costEditForm,
                            new_payment: parseFloat(e.target.value) || 0
                          })}
                          className={styles.form_input_small}
                          min="0"
                          step="0.01"
                          placeholder="Shuma"
                        />
                        <input
                          type="date"
                          value={costEditForm.selected_date}
                          onChange={(e) => setCostEditForm({
                            ...costEditForm,
                            selected_date: e.target.value
                          })}
                          className={styles.form_input_small}
                        />
                        <button 
                          type="button" 
                          className={styles.add_btn_small}
                          onClick={addNewPayment}
                          disabled={costEditForm.new_payment <= 0}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.popup_actions}>
                <button 
                  type="button" 
                  className={styles.cancel_btn}
                  onClick={() => setShowCostEditPopup(false)}
                >
                  Anulo
                </button>
                <button 
                  type="button" 
                  className={styles.save_btn}
                  onClick={saveCostChanges}
                  disabled={costEditForm.patient_pay > costEditForm.service_cost}
                >
                  Ruaj
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Services Modal */}
      {showServicesModal && (
        <div className={styles.services_modal_overlay}>
          <div className={styles.services_modal}>
            <div className={styles.modal_header}>
              <h3>
                {t('services_for')} {selectedDateServices[0]?.date ? new Date(selectedDateServices[0].date).toLocaleDateString('en-GB') : ''}
              </h3>
              <button 
                className={styles.close_modal_btn}
                onClick={() => setShowServicesModal(false)}
              >
                ✖
              </button>
            </div>
            <div className={styles.modal_content}>
              <div className={styles.services_list}>
                {selectedDateServices.map((service) => (
                  <div
                    key={service.id}
                    className={`${styles.modal_service_item} ${service.id === currentOperation?.id ? styles.active_modal_service : ''}`}
                    onClick={() => handleServiceSelect(service)}
                  >
                    <div className={styles.modal_service_header}>
                      <span 
                        className={styles.modal_service_name}
                        style={{ color: getServiceColor(service.name || service.operation_name) }}
                      >
                        {service.name || service.operation_name}
                      </span>
                      <div className={styles.modal_service_actions}>
                        <button 
                          className={styles.cost_edit_btn}
                          onClick={(e) => {
                            e.stopPropagation()
                            setShowServicesModal(false)
                            openCostEditPopup(e, service)
                          }}
                          title={t('edit_cost')}
                        >
                          <span role="img" aria-label="edit cost">💶</span>
                        </button>
                        <button 
                          className={styles.delete_service_btn}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleDeleteService(e, service)
                          }}
                          title={t('delete_service')}
                        >
                          <DeleteIco className={styles.delete_icon} />
                        </button>
                      </div>
                    </div>
                    <div className={styles.modal_service_details}>
                      {(service.service_cost !== undefined || service.price !== undefined) && (
                        <div className={styles.modal_cost_info}>
                          <span className={styles.cost_label}>{t('cost')}:</span>
                          <span className={styles.cost_value}>
                            {service.service_cost !== undefined ? service.service_cost : (service.price !== undefined ? service.price : 0)} €
                          </span>
                        </div>
                      )}
                      {service.description && (
                        <div className={styles.modal_service_description}>
                          {service.description}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PatientPage